//点击变体替换价格和样式
let list = document.querySelectorAll(".glamping-booster_variant-list li")
let original_price = document.querySelector(".glamping-booster_variant-price-group #original_price span")
let price = document.querySelector(".glamping-booster_variant-price-group #price span")
let buynow = document.querySelector("#glamping_booster-buynow")
let selectype =  document.querySelector(".tm-user-select");
for(let i=0;i<list.length;i++){
  list[i].onclick = function(){
    for(let j = 0;j<list.length;j++){
      list[j].classList.remove('active')
    }
    this.classList.add('active')
    original_price.innerHTML = this.getAttribute("original-price")
    price.innerHTML = this.getAttribute("price")
    buynow.href=this.getAttribute("url");
    selectype.innerHTML = this.getAttribute("name");
  }
}

//点击最下方的stickyBox替换样式
let stickyPcBox = document.querySelectorAll(".sticky-box-tab-pc .sticky-box-left a")
let stickyPhoneBox = document.querySelectorAll(".sticky-box-tab-phone .sticky-box-left a")
let sticky_box_right_1 = document.querySelector("#sticky-box-right-1")
let sticky_box_right_2 = document.querySelector("#sticky-box-right-2")
let sticky_box_right_3 = document.querySelector("#sticky-box-right-3")
for(let i = 0;i<stickyPcBox.length;i++){
  stickyPcBox[i].onclick = function(){
    removeStickyBoxActive()
    this.classList.add('active')
  }
  stickyPhoneBox[i].onclick = function(){
    removeStickyBoxActive()
    this.classList.add('active')
  }
}
function removeStickyBoxActive(){
  for(let j = 0;j<stickyPcBox.length;j++){
      stickyPcBox[j].classList.remove('active')
      stickyPhoneBox[j].classList.remove('active')
  }
}





  //当屏幕宽度小于768时，取消掉某些dom的定位滚动特效，因为此时的高度已经超过了100%,此特效会覆盖掉下面的内容
  removeScrollMaggicDom()
  window.onresize = function(){
    removeScrollMaggicDom()
  }
  function removeScrollMaggicDom(){
    let width = window.screen.width
    if(width <= 768){
      document.querySelector("#glamping-companion_variant-content").classList.remove('scrollMagic')
    }
  }
  
  function showleftStick(index){
    removeStickyBoxActive(index)
    stickyPcBox[index].classList.add('active')
    stickyPhoneBox[index].classList.add('active')
  }


  //scrollMagic

  var controller = new ScrollMagic.Controller({
  globalSceneOptions: {
    triggerHook: 'onLeave',
    duration: "200%" // this works just fine with duration 0 as well
  }
  });

  // get all slides
  var slides = document.querySelectorAll(".scrollMagic");
  
  // create scene for every slide
  for (var i=0; i<slides.length; i++) {
    new ScrollMagic.Scene({
        triggerElement: slides[i]
      })
      .setPin(slides[i], {pushFollowers: false})
      .addTo(controller);
  }

  //scrollMagic


  //stickyBox滚动交互 (通过监听inview事件，动态决定显现哪一块dom元素)
  // let stickyAll = document.querySelectorAll(".sticky-box-right>div")
  // let sticky1 = document.querySelector("#sticky-box-right-1")
  // let sticky2 = document.querySelector("#sticky-box-right-2")
  // let sticky3 = document.querySelector("#sticky-box-right-3")
  // let showSticky = document.querySelector(".sticky-box-show")
  // sticky1.addEventListener('inview', function () {
  //       handleShowStickyBox(1)
  // });
  // sticky2.addEventListener('inview', function () {
  //       handleShowStickyBox(2)
  //   });
  // sticky3.addEventListener('inview', function () {
  //       handleShowStickyBox(3)
  // });
  // function handleShowStickyBox(index){
  //   showSticky.innerHTML = stickyAll[index].innerHTML
  //   showleftStick(index-1)
  // }

